import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferAppleMusicToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.transferAppleMusicToTidal}
            sections={<PairTransferGuideContent sourceKey="appleMusic" destKey="tidal" />}
        />
    );
}
